import { OrderAction, OrderState } from "../types/order";
import {
  INCREMENT_ORDER_CURRENT_PAGE,
  ORDER_CREATE_DONE,
  ORDER_CREATE_START,
  ASYNC_ORDER_COMPLETED,
  ASYNC_ORDER_FAILED,
  ORDERS_ADD,
  RESET_ORDER_CURRENT_PAGE,
  SIGNOUT,
} from "../constants/actionTypes";

const initialState: OrderState = {
  all: [],
  ordersLoading: false,
  currentPage: 1,
  isOrderProcessing: false,
};

const applyCreateOrderStart = (state: OrderState) => ({
  ...state,
  ordersLoading: true,
  isOrderProcessing: true,
});

const applyCreateOrderDone = (state: OrderState, action: any) => {
  const { order, keepProcessing } = action.payload || {};
  return {
    ...state,
    all: order ? [...state.all, order] : state.all,
    ordersLoading: false,
    isOrderProcessing: keepProcessing ?? false,
  };
};

const applyAsyncOrderCompleted = (state: OrderState) => ({
  ...state,
  ordersLoading: false,
  isOrderProcessing: false,
});

const applyAsyncOrderFailed = (state: OrderState) => ({
  ...state,
  ordersLoading: false,
  isOrderProcessing: false,
});

const applyAddOrders = (state: OrderState, action: any) => ({
  ...state,
  all: action.payload,
});

const applyIncrementPage = (state: OrderState) => ({
  ...state,
  currentPage: state.currentPage + 1,
});

const resetCurrentOrderPage = (state: OrderState) => ({
  ...state,
  currentPage: 1,
});

const orderReducer = (
  state: OrderState = initialState,
  action: OrderAction,
): OrderState => {
  switch (action.type) {
    case ORDERS_ADD:
      return applyAddOrders(state, action);
    case ORDER_CREATE_DONE:
      return applyCreateOrderDone(state, action);
    case ORDER_CREATE_START:
      return applyCreateOrderStart(state);
    case ASYNC_ORDER_COMPLETED:
      return applyAsyncOrderCompleted(state);
    case ASYNC_ORDER_FAILED:
      return applyAsyncOrderFailed(state);
    case INCREMENT_ORDER_CURRENT_PAGE:
      return applyIncrementPage(state);
    case RESET_ORDER_CURRENT_PAGE:
      return resetCurrentOrderPage(state);
    case SIGNOUT:
      return initialState;
    default:
      return state;
  }
};

export default orderReducer;
